import { render, staticRenderFns } from "./product_abnormal.vue?vue&type=template&id=5b99cae5&scoped=true"
import script from "./product_abnormal.vue?vue&type=script&lang=js"
export * from "./product_abnormal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b99cae5",
  null
  
)

export default component.exports